import * as React from "react";
import Button from "@mui/material/Button";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import Grid from '@mui/material/Grid';
import moment from "moment";
import Tooltip from '@mui/material/Tooltip';
import { Edit } from "../../node_modules/@material-ui/icons/index";
import { makeStyles } from "@mui/styles";
import {logger} from '../utils';

export default function EditDayDialog({ handleDialogCallback, data, taskFields, week }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [User, setUser] = React.useState('');
    const [TaskID, setTaskID] = React.useState('');
    const [role, setRole] = React.useState('');
    const [Hours, setHours] = React.useState(0);
    const [timeType, setTimeType] = React.useState("NT")
    const [lab, setLab] = React.useState(0)
    const [day, setDay] = React.useState(week)
    const [propList, setPropListChoices] = React.useState([]);
    const [ignored, forceupdate] = React.useReducer(x => x + 1, 0);

    const separatorList = {
        period: {
            name: "period",
            regex: /^\d+(\.\d{0,2})?$/
        }
    };
    logger(`editday data`, data)
  //  logger(`editday taskFields`, taskFields)
 //   logger(`editday week`, week)
    function handleChange(event) {
        setTaskID(event.target.value);
        let temp = TaskChoices.filter(obj => obj.value === event.target.value)

        fetch(`/api/task_variable/${temp[0].GroupID}/${temp[0].value}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setPropList(json))
            .then(logger(propList))
    };

    async function ChangePropList(e, i) {
        const clonedData = propList

        clonedData[i].TaskItemID = e.target.value

        setPropListChoices(clonedData)
        forceupdate();
    };


    const [RoleChoices, setRolesChoices] = React.useState([])
    const [UserChoices, setUserChoices] = React.useState([])
    const [TaskChoices, setTaskChoices] = React.useState([])
    const [TimeEntry, setTimeEntry] = React.useState([])
    const [TaskProp, setTaskProp] = React.useState([])
    const [taskItemChoices, setTaskItemChoices] = React.useState([]);
    const [expand, setExpand] = React.useState(true);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
	const pageStyles = makeStyles((theme) => ({
		root: {
			 '& .MuiInputBase-root': {
			 backgroundColor: "#FFFFFF",
		     padding: '5px 10px 5px',
		     height: '100px',
		            
			 },
		 },
	}));
			
	const classes = pageStyles();
	
    const setUsers = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.FirstName + " " + choice.LastName, value: choice.ID, default: choice.IV, assigned: choice.AssignedTo }))
        setUserChoices(choices)
    }

    const setPropList = async (props) => {
        logger(`in setPropList`, props)
        let choices = [];
        props.forEach(choice => choices.push({ label: choice.Name, TaskVariableID: choice.TaskVariableID, TaskItemID: choice.TaskItemID ? choice.TaskItemID : '', IsDropdown: choice.IsDropdown }))
        setPropListChoices(choices)
    }

    const setTaskItem = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID, TaskVariableID: choice.TaskVariableID }))
        setTaskItemChoices(choices)
    }

    const setRoles = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Lab + "-" + choice.Position, value: choice.ID, lab: choice.LabID }))
        setRolesChoices(choices)
    }

    const setTask = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID, GroupID: choice.GroupID }))
        setTaskChoices(choices)
    }

    async function setEdit (TimeEntry, TEProps) {
     //   logger(`in setEdit`, TimeEntry)
     //  logger(`in setEditProps`, TEProps)
        setUser(TimeEntry.UserID)
       
        setDay(moment.utc(TimeEntry.DayOf).format('YYYY-MM-DD'))
      
        setTaskID(TimeEntry.TaskID)
       
        setRole(TimeEntry.RoleID)
       
        setHours(TimeEntry.Hours.toString())

        setTimeType(TimeEntry.FlagType)
       
        let choices = [];
        TEProps.forEach(choice => choices.push({ label: choice.label, TaskVariableID: choice.TaskVariableID, TaskItemID: choice.IsDropdown ? choice.TaskItemID : choice.Data, IsDropdown: choice.IsDropdown }))
        //logger(`Propchoices`,choices)
        setPropListChoices(choices)
        return;
     //   forceupdate
    }

    async function getUsers() {
        if (!UserChoices.length) {
            await fetch('/api/User/dropdown/hierarchy', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                    setUsers(json)
                    //logger(`getUser`, json)
                });
        } return;
   
    }
    const getEdit = async (timeEntryID) => {
        try {
     
              //logger(`/api/Time_Entry/Edit/${timeEntryID}`);
                const res = await fetch(`/api/Time_Entry/Edit/${timeEntryID}`, { method: 'Get' });
                const json = await res.json();
                const TimeEntry = json[0];
                logger(`getEdit`, TimeEntry);
                return TimeEntry;
        } catch (error) {
            console.error(`Error fetching TimeEntry Data ${timeEntryID}`, error);
            return null;
        }
    }
    async function getProps(timeEntryID) {
        try {
            const res = await fetch(`/api/time_entry_prop/${timeEntryID}`, { method: 'Get' })
            const json = await res.json();
            const propData = json;
                    logger(`getProps`, propData)
                    return propData;
        } catch (error) {
            console.error(`Error fetching TE Props Data ${timeEntryID}`, error);
            return null;
        }
    }
    /*async function getEdit(timeEntryID) {
        if (!User.length) {
            logger(`/api/Time_Entry/Edit/${timeEntryID}`)
            await fetch(`/api/Time_Entry/Edit/${timeEntryID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                   let TimeEntry = json[0]
                    logger(`getEdit`, TimeEntry)
                    return (TimeEntry);
                });
        } return Promise.resolve(null);
    }*/
    async function CheckBilled(labOf, TaskOf, dayOf) {
     //   const CheckBilled = async (labOf, TaskOf, dayOf) => {
        try {
            const res = await fetch(`/api/Time_Entry/CheckBilled/${labOf}/${TaskOf}`, { method: 'Get' })
            const json = await res.json();
            return json
        } catch (error) {
            console.error(`Error fetching TE Props Data ${timeEntryID}`, error);
            return;
        }
         
    }
    

    const Check = async (list) => {
        let output = false;
                list.forEach((e, index) => {
                    if (moment(day).isBetween(e.StartDate, e.EndDate)) {
                        setAlertText("This time period has been locked. Check Entries or contact your Lead for assistance")
                        setAlert(true)
                        output = true;
                    }
                })
                if (!output) {
                    logger('will be saved')
                    onTrigger()
                }
    }
    async function getPropItems() {
        logger(`in getPropItems`)
        try {
          //  if (!TaskItemChoices.length) {
                const res = await fetch('api/task_prop_item', { method: 'Get' })
                const json = await res.json();
                setTaskItem(json)
                logger(`getItem`, json)

          //  }
            return null;
        } catch (error) {
            console.error(`Error fetching TE Props Data ${timeEntryID}`, error);
            return null;
        }
 
    }
    async function getRole(User) {
        let sql = `api/role/dropdown/${User}`
        //logger(`getrole-`,sql)
        try {
            const res = await fetch(sql, {method: 'Get' })
            const json = await res.json();
            setRoles(json)
            logger(`getRole`, json)
        } catch (error) {
            console.error(`Error fetching Task Dropdown Data ${timeEntryID}`, error);
            return null;
        }
    }
    async function getTask(timeEntryID) {
        try { 
            
        const res = await fetch('api/Task/dropdown', {method: 'Get' })
        const json = await res.json();
            setTask(json)
            logger(`in getTask`, json)
            return;
        } catch (error) {
            console.error(`Error fetching Task Dropdown Data ${timeEntryID}`, error);
            return null;
        } 
    }

    async function processData(data, taskFields, week) {
        try {
            
            const newTimeEntry = await getEdit(data.ID)
            const loadProps = await getProps(data.ID)
            const loadTask = await getTask(data.ID)
            logger(`back from getTask`)
            const loadItems = await getPropItems()

            if (newTimeEntry) {
                //logger(`processdata loadProps`, loadProps)
                //logger(`processdata newTimeEntry`, newTimeEntry);
                const loadTimeEntry = await setEdit(newTimeEntry, loadProps);
                const loadRole = await getRole(newTimeEntry.UserID)
            }
            const loadUserID = await getUsers()     

            
            logger(`await loadprops`, loadProps)
            logger(`props`, TaskProp)
            logger (`task choices`, TaskChoices)
            logger(`User Choices `, UserChoices)
            logger(`Role Choices `, RoleChoices)
            logger(`Task Item Choices `,taskItemChoices)

        } catch (error) {
            console.error(`Error loading TimeEntry Data ${data.ID}`, error)
        }

    }

    React.useEffect(() => {
        if (refresh) {
            if (open) {
                processData(data, taskFields, week);
                //     getTaskProp(data.ID)
                //          .then(loadEdit())
                //          .then(
                //      loadUsers()
                //          .then(
                /*  fetch(`api/role/dropdown/${User}`, {
                      method: 'Get',
                  })
                      .then(res => res.json())
                      .then(json => setRoles(json))
                  ))*/
                /*fetch('api/Task/dropdown', {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setTask(json));*/

                /*fetch('api/task_prop_item', {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => { setTaskItem(json) });*/

                setRefresh(false);
            }
           
        }
    })

    const onTrigger = React.useCallback(() => {


        const msg = {
            ID: data.ID,
            TaskID: TaskID,
            RoleID: role,
            Hours: Hours,
            TimeType: timeType,
            DayOf: day,
            propList: propList
        };

        handleDialogCallback(msg)
        setTaskID("");
        setHours(0);
        setDay(week);
        setTimeType("NT");
        setPropListChoices([]);
        handleClose();
    })

    const handleClickOpen = () => {
        logger("Edit was opened")
        logger(data)
        logger(taskFields)
        setRefresh(true)
        setOpen(true);
    };
    const handleAlertClose = () => {
        setAlert(false);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Tooltip title="Edit Entry" placement="top-end">
            <IconButton
                variant="contained"
                onClick={handleClickOpen}
                disabled={data.IsLocked === 1}
            >
                <BorderColorRoundedIcon color={data.IsLocked === 1 ? "disabled" : "primary"}/>
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose}>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                            Edit Time
                        </Typography>
                        <Button autoFocus color="inherit" onClick={() => {
							var mins = Hours.toString().substring(Hours.toString().indexOf(".")+1);
							/*console.log(Hours.indexOf(".")!==-1);*/
							if (mins !== null && mins !== "" && Hours.indexOf(".")!==-1 && (mins.length === 1 ? parseInt(mins + "0") : parseInt(mins)) % 25 !== 0) {
								setAlertText(`Please add time by the quarter hour(" .25 , .5 , .75 ")`);
								setAlert(true);
								return;
							}
                            if (Hours != 0) {
                                CheckBilled(lab, TaskID, day)
                                    .then(response => Check(response))
                            } else {
                                setAlertText("you need to add time")
                                setAlert(true)
                            }
                        }}>
                            save
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ display: "column", flexDirection: "row" }}>
                        <FormControl style={{ minWidth: 240, display: "flex", flexDirection: "row" }}>
                            <InputLabel id="UserSelection">
                                User
                            </InputLabel>
                            <Select
                                disabled
                                size="large"
                                sx={{ m: 1 }}
                                style={{ textAlign: 'center', minWidth: 200}}
                                labelId="UserSelection"
                                id="UserSelection"
                                value={User}
                                label="User"
                                onChange={e => {
                                    setUser(e.target.value);
                                    /*  setRole(e.target.DefaultRoleID);
                                      setLab(e.target.DefaultLab);*/
                                    UserChoices.forEach(choice => {
                                        if (e.target.value === choice.value) {
                                            setRole(choice.DefaultRoleID);
                                            setLab(choice.DefaultLab)
                                        }
                                    });
                                    setRefresh(true);
                                }}
                            >
                                {UserChoices.map((Choice, index) => {
                                    if ((Choice.assigned == Choice.default || Choice.default == Choice.value) || expand) {
                                        return (

                                            <MenuItem value={Choice.value}>{Choice.label}</MenuItem>
                                        );
                                    }
                                })}
                            </Select>
                            <FormControlLabel style={{ paddingRight: '5px'}} control={<Checkbox checked={expand} onClick={() => { setExpand(!expand); }} />} />
                        </FormControl>
                        <FormControl style={{ minWidth: 240 }}>
                            <InputLabel id="RoleSelection">
                                Roles
                            </InputLabel>
                            <Select
                                size="large"
                                sx={{ m: 1 }}
                                style={{ textAlign: 'center' }}
                                labelId="RoleSelection"
                                id="RoleSelectonDropdown"
                                value={role}
                                label="Lab"
                                onChange={e => {
                                    setRole(e.target.value)
                                    let temp = RoleChoices.filter(Choice => Choice.value == e.target.value)
                                    logger(RoleChoices.filter(Choice => Choice.value == e.target.value))
                                    setLab(temp[0].lab)
                                    logger(`Role: ${role} AND Lab: ${lab} AND Target: ${e.target.value}`)
                                    //setRefresh(true);
                                }}
                            >
                                {RoleChoices.map((Choice, index) => {
                                    return (
                                        <MenuItem value={Choice.value}>{Choice.label}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                        <div>
                        <FormControl style={{ minWidth: 240 }}>
                            <InputLabel id="DaySelection">
                                Day
                            </InputLabel>
                            <Select
                                size="large"
                                sx={{ m: 1 }}
                                style={{ textAlign: 'center' }}
                                    labelId="DaySelection"
                                    id="DaySelection"
                                value={day}
                                label="Day"
                                onChange={e => setDay(e.target.value)}
                            >
                                <MenuItem value={week}>Mon {moment(week).format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(1, 'days').format('YYYY-MM-DD')}>Tue {moment(week).add(1, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(2, 'days').format('YYYY-MM-DD')}>Wed {moment(week).add(2, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(3, 'days').format('YYYY-MM-DD')}>Thu {moment(week).add(3, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(4, 'days').format('YYYY-MM-DD')}>Fri {moment(week).add(4, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(5, 'days').format('YYYY-MM-DD')}>Sat {moment(week).add(5, 'days').format('MM-DD-YYYY')}</MenuItem>
                                <MenuItem value={moment(week).add(6, 'days').format('YYYY-MM-DD')}>Sun {moment(week).add(6, 'days').format('MM-DD-YYYY')}</MenuItem>
                            </Select>
                            </FormControl>
                            </div>
                        <FormControl style={{ minWidth: 240 }}>
                            <InputLabel id="TaskSelection">
                                Task
                            </InputLabel>
                            <Select
                                disabled
                                size="large"
                                sx={{ m: 1 }}
                                style={{ textAlign: 'center' }}
                                labelId="TaskSelection"
                                id="TaskSelection"
                                value={TaskID}
                                label="Task"
                                onChange={handleChange}
                            >
                                {TaskChoices.map((Choice, index) => {
                                    return (
                                        <MenuItem value={Choice.value}>{Choice.label}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                        <div style={{ verticalAlign: "bottom" }}>
                            <FormControl style={{ minWidth: 100 }}>
                                <TextField
                                    label="Hours"
                                    sx={{ m: 1}}
                                    id="outlined-number"
                                    value={Hours}
                                    type="number"
                                    InputProps={{
                                        inputProps: {
                                            max: 24,
                                            min: 0,
                                            style: {
                                                textAlign: "center",
                                                minWidth: 120,
                                                height:28,
                                                marginTop:9,
                                                paddingTop:0,
                                                paddingLeft:4,
                                                
                                            }
                                        }
                                    }}
                                    onChange={e => {
                                        if (separatorList["period"].regex.test(e.target.value)) {
                                            setHours(e.target.value);
                                        }
                                    }}
                                />
                            </FormControl>
                            <FormControl style={{ minWidth: 120 }}>
                                <InputLabel id="OTSelection">
                                    NT/OT
                                </InputLabel>
                                <Select
                                    size="large"
                                    sx={{ m: 1 }}
                                    style={{ textAlign: 'center' }}
                                    labelId="OTSelection"
                                    id="OTSelection"
                                    value={timeType}
                                    label="NT/OT"
                                    onChange={e => setTimeType(e.target.value)}
                                >
                                    <MenuItem value={'NT'}>NT</MenuItem>
                                    <MenuItem value={'OT'}>OT</MenuItem>
                                    <MenuItem value={'WND'}>WND</MenuItem>
                                    <MenuItem value={'HOL'}>HOL</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div>
                        {propList.map((p, index) => {
                            if (p.IsDropdown) {
                                return (
                                    <div key="divprop-{index}">
                                        <FormControl style={{ minWidth: 240 }}>
                                            <InputLabel id={p.label + index}>
                                                {p.label}
                                            </InputLabel>
                                            <Select
                                                size="large"
                                                sx={{ m: 1 }}
                                                style={{ textAlign: 'center' }}
                                                labelId={p.label}
                                                id="prop-{index}"
                                                value={p.TaskItemID}
                                                label={p.label}
                                                onChange={e => ChangePropList(e, index)}
                                            >
                                                {taskItemChoices.map((Choice, i) => {
                                                    if (Choice.TaskVariableID == p.TaskVariableID) {

                                                        return (
                                                            <MenuItem key="value-{i}" value={Choice.value}>{Choice.label}</MenuItem>
                                                        );

                                                    }
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={index}>
                                        <FormControl className={classes.root}style={{ minWidth: 240 }}>
                                            <TextField
                                                id={index}
                                                label={p.label}
                                                multiline
                                                rows={4}
                                                value={p.TaskItemID}
                                                onChange={e => ChangePropList(e, index)}
                                            />
                                        </FormControl>
                                    </div>
                                );
                            }
                        })}
                    </div>
                </DialogContent>
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="L&P Lock"
                    aria-describedby="Time Period locked for this work"
                >
                    <DialogTitle id="Time Entry">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {AlertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
        </div>
    );
}